/* Current-market Ajax product prices. Only requested result cards fetch product data. */
(() => {
  'use strict';
  const cache = new Map();
  const german = /^de(?:-|$)/i.test(document.documentElement.lang || '');
  function market() {
    return { currency:window.Shopify?.currency?.active || '', root:window.Shopify?.routes?.root || '/' };
  }
  function format(cents, currency = market().currency) {
    if (!Number.isFinite(cents) || !currency) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IE', { style:'currency', currency }).format(cents / 100);
    } catch (_) { return ''; }
  }
  function product(handle, scope) {
    const key = `${scope.currency}|${scope.root}|${handle}`;
    if (!cache.has(key)) {
      const root = scope.root.endsWith('/') ? scope.root : `${scope.root}/`;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      const request = fetch(`${root}products/${encodeURIComponent(handle)}.js`, { credentials:'same-origin', signal:controller.signal })
        .then(response => { if (!response.ok) throw new Error(`Product response ${response.status}`); return response.json(); })
        .then(data => { if (!Number.isFinite(data.price)) throw new Error('Missing presentment price'); return data; })
        .catch(error => { cache.delete(key); throw error; })
        .finally(() => clearTimeout(timeout));
      cache.set(key, request);
    }
    return cache.get(key);
  }
  function fallback(node, handle, root) {
    const link = document.createElement('a');
    link.href = `${root.endsWith('/') ? root : `${root}/`}products/${encodeURIComponent(handle)}`;
    link.textContent = 'View details';
    node.replaceChildren(link);
    node.removeAttribute('aria-busy');
  }
  function hydrate(container) {
    if (german || !container) return;
    const scope = market();
    container.querySelectorAll('[data-be-live-product-price][data-product-handle]').forEach(node => {
      const handle = node.dataset.productHandle;
      if (!handle || !/^[a-z0-9-]+$/.test(handle)) return;
      const key = `${scope.currency}|${scope.root}|${handle}`;
      if (node.dataset.priceScope === key) return;
      node.dataset.priceScope = key;
      if (!scope.currency) { fallback(node, handle, scope.root); return; }
      node.setAttribute('aria-busy', 'true');
      product(handle, scope).then(data => {
        if (!node.isConnected || node.dataset.priceScope !== key) return;
        const varies = data.price_varies === true || (Number.isFinite(data.price_min) && data.price_min !== data.price_max);
        const amount = varies && Number.isFinite(data.price_min) ? data.price_min : data.price;
        const price = format(amount, scope.currency);
        if (!price) { fallback(node, handle, scope.root); return; }
        node.textContent = `${varies ? 'From ' : ''}${price}`;
        node.dataset.priceStatus = 'current-market';
        node.dataset.priceCurrency = scope.currency;
        node.removeAttribute('aria-busy');
      }).catch(() => { if (node.isConnected && node.dataset.priceScope === key) { node.dataset.priceStatus = 'unavailable'; fallback(node, handle, scope.root); } });
    });
  }
  window.BELiveProductPricing1003 = Object.freeze({ hydrate, format });
  const init = () => hydrate(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
